import { render } from "./PermissionAction.vue?vue&type=template&id=1213163c&scoped=true"
import script from "./PermissionAction.vue?vue&type=script&lang=js"
export * from "./PermissionAction.vue?vue&type=script&lang=js"

import "./PermissionAction.vue?vue&type=style&index=0&id=1213163c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1213163c"]])

export default __exports__